export { default } from './UserFlowFundsService';



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/userFlowFunds/services/UserFlowFundsService/index.js